import { z } from 'zod'

// Каталог видов — зеркало `notification.AllKinds` бэка, порядок тот же (сверяется
// глазами). Вид вне каталога роняет разбор всей ленты, поэтому расширение каталога
// на бэке требует релиза SPA следом.
export const NotificationKindSchema = z.enum([
  'task-assigned',
  'task-unassigned',
  'task-taken-over',
  'task-bulk-assigned',
  'task-moved',
  'project-assigned',
  'project-unassigned',
  'mentioned',
  'deadline-approaching',
  'deadline-changed',
  'deadline-missed',
  'dependency-unblocked',
  'pomodoro-phase',
  'idle-suspected',
])
export type NotificationKind = z.infer<typeof NotificationKindSchema>

// idleProposalId/proposedStoppedAt — только у kind=idle-suspected: цель действий
// «обрезать до proposedStoppedAt / оставить». readAt=null → непрочитано (● в ленте).
export const NotificationSchema = z.object({
  id: z.string(),
  employeeId: z.string(),
  kind: NotificationKindSchema,
  title: z.string(),
  body: z.string().optional(),
  taskId: z.string().optional(),
  idleProposalId: z.string().optional(),
  proposedStoppedAt: z.string().optional(),
  createdAt: z.string(),
  readAt: z.string().nullable(),
})
export type Notification = z.infer<typeof NotificationSchema>

// Подписка сотрудника на вид алерта в телеграме. Лента настройке не подлежит —
// она источник истины и пишется всегда.
export const NotificationSubscriptionSchema = z.object({
  kind: NotificationKindSchema,
  enabled: z.boolean(),
})
export type NotificationSubscription = z.infer<typeof NotificationSubscriptionSchema>
